/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_TitleInputs */

const en_directory_agents_title = /** @type {(inputs: Directory_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let your agent launch your product`)
};

const zh_directory_agents_title = /** @type {(inputs: Directory_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让你的 Agent 替你发布产品`)
};

/**
* | output |
* | --- |
* | "Let your agent launch your product" |
*
* @param {Directory_Agents_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_title = /** @type {((inputs?: Directory_Agents_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_title(inputs)
	return zh_directory_agents_title(inputs)
});
export { directory_agents_title as "directory.agents.title" }